import { useEnvironment } from '#core/Environment';

const NewRelic = () => {
  const {
    newRelicConfig: { accountId: accountID, appId: applicationID, licenseKey },
  } = useEnvironment();

  if (
    [accountID, applicationID, licenseKey].every(
      (config) => typeof config !== 'undefined' && config !== null,
    )
  ) {
    window.NREUM.loader_config = {
      accountID,
      trustKey: accountID,
      agentID: applicationID,
      licenseKey,
      applicationID,
    };
    window.NREUM.info = {
      beacon: 'bam.eu01.nr-data.net',
      errorBeacon: 'bam.eu01.nr-data.net',
      licenseKey,
      applicationID,
      sa: 1,
    };
  }

  return null;
};

export default NewRelic;
